<template>
	<div id="app">
		<router-view />
		<ScreenDialog ref="screenDialog"></ScreenDialog>
		<div v-if="$isMobile && !isLandscape" class="orientation-prompt">
			<p>请将设备旋转至横屏以获得最佳体验。</p>
		</div>
		<div v-if="!isFullscreen" class="fullscreen-btn" @click="enterFullscreen">
			<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
				<path d="M8 3H5a2 2 0 0 0-2 2v3" />
				<path d="M16 3h3a2 2 0 0 1 2 2v3" />
				<path d="M8 21H5a2 2 0 0 1-2-2v-3" />
				<path d="M16 21h3a2 2 0 0 0 2-2v-3" />
			</svg>
			<span>进入全屏</span>
		</div>
	</div>
</template>

<script>
	import ScreenDialog from "@/views/my/dialog/ScreenDialog.vue";

	export default {
		components: {
			ScreenDialog,
		},
		data() {
			return {
				isFullscreen: this.$local.isFullscreen(),
				isLandscape: false,

			};
		},
		watch: {
			isFullscreen: {
				handler(val) {
					if (!val) {
						if (this.$isMobile) {
							if (this.getLandscape()) {
								// this.$message.warning("请在非游戏模式下双击屏幕，进入全屏显示");
							}
						} else {
							this.$message.warning("请按A键，进入全屏显示");
						}
					}
				},
				immediate: true,

			}
		},

		mounted() {
			// this.setAppSize(true);
			
			if (this.$isMobile) {
				// window.addEventListener('resize', this.reloadApp);
				window.addEventListener('orientationchange', this.reloadApp);
			}
			window.addEventListener("keyup", this.handlerKeyUp);
			window.addEventListener("keydown", this.handlerKeyDown);
			window.addEventListener("resize", this.updateFullscreenStatus);
			document.addEventListener('fullscreenchange', this.updateFullscreenStatus);
			document.addEventListener('webkitfullscreenchange', this.updateFullscreenStatus);
			document.addEventListener('mozfullscreenchange', this.updateFullscreenStatus);
			document.addEventListener('MSFullscreenChange', this.updateFullscreenStatus);
		},
		methods: {

			getOrientation() {
				if (window.orientation) return window.orientation;
				if (window.screen.orientation && window.screen.orientation.angle)
					return window.screen.orientation.angle;
				return 0;
			},

			getLandscape() {
				const angle = this.getOrientation();
				this.isLandscape = angle == 90 || angle == -90;
				return this.isLandscape;
			},

			setAppSize(flag) {
				this.getLandscape();
				const app = document.getElementById('app');
				if (this.$isMobile) {
					app.style.width = `${window.innerWidth}px`;
					app.style.height = `${window.innerHeight}px`;
					console.log('mobile')
				} else {
					app.style.width = `${screen.width}px`;
					app.style.height = `${screen.height}px`;
					console.log("screen：",screen);
				}

			},

			handlerKeyUp(e) {
        if(this.$isMobile) return;
				if (e.key == "q" || e.key == "Q") {
					this.$refs.screenDialog.init(this.$local.getScreenSize());
				}
				if (e.key == "a" || e.key == "A") {
					this.enterFullscreen();
				}
			},

			// 拦截 F11：Edge 的 F11 全屏不完整，统一走 Fullscreen API，保证全屏状态一致
			handlerKeyDown(e) {
				if (e.key === "F11") {
					e.preventDefault();
					if (this.$local.isFullscreen()) {
						const doc = document;
						if (doc.exitFullscreen) {
							doc.exitFullscreen();
						} else if (doc.webkitExitFullscreen) {
							doc.webkitExitFullscreen();
						} else if (doc.mozCancelFullScreen) {
							doc.mozCancelFullScreen();
						} else if (doc.msExitFullscreen) {
							doc.msExitFullscreen();
						}
					} else {
						this.enterFullscreen();
					}
					// 浏览器切换全屏需短暂时间，延迟后重新检查全屏状态
					setTimeout(() => {
						this.updateFullscreenStatus();
					}, 150);
				}
			},

			// 进入全屏
			enterFullscreen() {
				const el = document.documentElement;
				if (el.requestFullscreen) {
					el.requestFullscreen();
				} else if (el.webkitRequestFullscreen) {
					// Safari 支持
					el.webkitRequestFullscreen();
				} else if (el.msRequestFullscreen) {
					// IE11 支持
					el.msRequestFullscreen();
				} else if (el.mozRequestFullScreen) {
					// Firefox 支持
					el.mozRequestFullScreen();
				}
			},

			// 监听全屏状态（兼容 F11 浏览器全屏与 Fullscreen API）
			updateFullscreenStatus() {
				this.isFullscreen = this.$local.isFullscreen();
			},

			reloadApp() {
				location.reload();
			}
		},
		beforeDestroy() {
			if (this.$isMobile) {
				// window.removeEventListener('resize', this.reloadApp);
				window.removeEventListener('orientationchange', this.reloadApp);
			}

			window.removeEventListener("keyup", this.handlerKeyUp);
			window.removeEventListener("keydown", this.handlerKeyDown);
			window.removeEventListener("resize", this.updateFullscreenStatus);
			document.removeEventListener('fullscreenchange', this.updateFullscreenStatus);
			document.removeEventListener('webkitfullscreenchange', this.updateFullscreenStatus);
			document.removeEventListener('mozfullscreenchange', this.updateFullscreenStatus);
			document.removeEventListener('MSFullscreenChange', this.updateFullscreenStatus);
		},
	};
</script>

<style lang="scss">
	#app {
		width: 100vw;
		height: 100vh;
	}

	.blackbk {
		position: relative;
		width: 100%;
		height: 100%;
		background-color: #000;
		overflow: hidden;
	}

	.orientation-prompt {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.75);
		font-size: 40px;
		color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
		/* 确保遮罩层位于其他内容之上 */
	}

	.fullscreen-btn {
		position: fixed;
		top: 20px;
		right: 20px;
		z-index: 9999;
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 10px 18px;
		border: 1px solid rgba(255, 255, 255, 0.6);
		border-radius: 8px;
		background-color: rgba(0, 0, 0, 0.45);
		color: #fff;
		font-size: 16px;
		line-height: 1;
		cursor: pointer;
		user-select: none;

		&:hover {
			background-color: rgba(0, 0, 0, 0.65);
		}
	}
</style>